import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { IEditCategoryContext, EditCategoryContext } from '../../../../..//editCategoryState/editCategoryContext';
import CustomerSelect from './components/CustomerSelect';
import RestaurantsMultipleSelect from './components/RestaurantsMultipleSelect/RestaurantsMultipleSelect';
import NameCategoryInput from './components/NameCategoryInput';
import CategoryTypeSelect from './components/CategoryTypeSelect';
import SubcategoriesList from './components/SubcategoriesList';
import IsRestrictedCheckBox from './components/IsRestrictedCheckBox';
import ActivationScheduleInput from './components/ActivationScheduleInput';
import DeactivationScheduleInput from './components/DeactivationScheduleInput';
import CronGenerator from 'components/CronGenerator/CronGenerator';
import BtnBlock from './components/BtnBlock';
import { Form } from 'antd';
import { getFileIdForSubmit, preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		setIDCustomer,
		setFetchedCustomers,
		setIDsRestaurant,
		setFetchedRestaurants,
		changeLoaderStatus,
		changeNameOfCategory,
		setCategoryType,
		toggleIsRestricted,
		changeActivationSchedule,
		changeDeactivationSchedule,
		initialIDsSelectedRestaurant,
		initialIDSelectedCustomer,
		subcategoriesOfCategory,
		fileId,
		filePath,
		categoryID,
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfCategory,
		categoryType,
		isRestricted,
		activationSchedule,
		deactivationSchedule,
		translations,
		defaultCustomerLanguage,
	} = useContext<IEditCategoryContext>(EditCategoryContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ IDSelectedCustomer });
		form.setFieldsValue({ IDsSelectedRestaurant });
		form.setFieldsValue({ nameOfCategory });
		form.setFieldsValue({ categoryType });
		form.setFieldsValue({ isRestricted });
		form.setFieldsValue({ activationSchedule });
		form.setFieldsValue({ deactivationSchedule });
	}, [
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfCategory,
		categoryType,
		isRestricted,
		activationSchedule,
		deactivationSchedule,
	]);

	const submit = async () => {
		const defaultTranslationIsEmpty =
			translations.find((translation) => translation.languageId === defaultCustomerLanguage?.id)?.name === '';
		if (defaultTranslationIsEmpty) {
			changeTypeOfModalWindow('defaultTranslationIsEmpty');
			return;
		}

		setDataForSubmit({
			id: categoryID,
			name: nameOfCategory,
			categoryType: categoryType || 'Default',
			customerId: IDSelectedCustomer || '',
			fileId: getFileIdForSubmit({ fileId, filePath }),
			categoryRestaurantIds: IDsSelectedRestaurant,
			isRestricted,
			activationCron: activationSchedule,
			deactivationCron: deactivationSchedule,
			translations,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<CustomerSelect
						setIDCustomer={setIDCustomer}
						setFetchedCustomers={setFetchedCustomers}
						initialIDSelectedCustomer={initialIDSelectedCustomer}
					/>
					<RestaurantsMultipleSelect
						setIDsRestaurant={setIDsRestaurant}
						setFetchedRestaurants={setFetchedRestaurants}
						changeLoaderStatus={changeLoaderStatus}
						IDSelectedCustomer={IDSelectedCustomer}
						initialIDsSelectedRestaurant={initialIDsSelectedRestaurant}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
					/>
					<NameCategoryInput changeNameOfCategory={changeNameOfCategory} />
					<CategoryTypeSelect setCategoryType={setCategoryType} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="subcategoriesHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<SubcategoriesList subcategoriesOfCategory={subcategoriesOfCategory} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restrictionHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<IsRestrictedCheckBox toggleIsRestricted={toggleIsRestricted} isRestricted={isRestricted} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="scheduleHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<ActivationScheduleInput changeActivationSchedule={changeActivationSchedule} />
						<DeactivationScheduleInput changeDeactivationSchedule={changeDeactivationSchedule} />
					</div>
					<CronGenerator />
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
